module.exports = __webpack_public_path__ + "static/img/b06.be3faf1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/b06.jpg
// module id = 78sk
// module chunks = 1